import { Col, Flex, Row } from "antd"
import { useDevice } from "hooks/useDevice"
import { ContentActionButtons } from "layoutsV2/pro/PersonalInfoLayout/ContentActionButtons"
import { ContentHeader } from "layoutsV2/pro/PersonalInfoLayout/ContentHeader"
import PaypalAccountCard from "pagesV2/pro/Settings/ProSettings/PaymentProviders/PaypalAccount/PaypalAccountCard"
import { StripeAccountCard } from "pagesV2/pro/Settings/StripeAccount/StripeAccountCard"
import { StripeActionButtons } from "pagesV2/pro/Settings/StripeAccount/StripeActionButtons"
import PowerTranzAccount from "pagesV2/pro/Settings/ProSettings/PaymentProviders/PowerTranzAccount"
import { usePowerTranzConnectOffer } from "hooks/usePowerTranzConnectOffer"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { isStripeChargesEnabledSelector, errorStripeMessage } from "store/user"

export const PersonalInfoStripe = () => {
  const { t } = useTranslation()
  const { isMobile } = useDevice()
  const isStripeChargeEnabled = useSelector(isStripeChargesEnabledSelector)
  const stripeErrorMessage = useSelector(errorStripeMessage)
  // Pilot guides can set up PowerTranz here too, same section as Settings > Payment Providers.
  const isPowerTranzOffered = usePowerTranzConnectOffer()

  return (
    <Row>
      <Col lg={16} md={24} xs={24}>
        <Flex vertical>
          <ContentHeader
            title={t("pro.personal_info.payment_provider.title")}
            description={t(
              isPowerTranzOffered
                ? "pro.personal_info.payment_provider.description_with_powertranz"
                : "pro.personal_info.payment_provider.description"
            )}
          />
          <StripeAccountCard
            className="mb-4xl"
            errorStripeMessage={stripeErrorMessage}
          />
          <PaypalAccountCard source="wizard" />
          {isPowerTranzOffered && (
            <Flex vertical className="mt-4xl">
              <PowerTranzAccount />
            </Flex>
          )}
          {isMobile && (
            <Flex justify="center" className="mb-4xl">
              <StripeActionButtons />
            </Flex>
          )}
        </Flex>
        <ContentActionButtons
          isStripeChargeEnabled={isStripeChargeEnabled}
          errorStripeMessage={stripeErrorMessage}
        />
      </Col>
    </Row>
  )
}